<template>
  <div id="proveedor-data">
    <v-form ref="form">
      <v-layout>
        <v-flex xs12 md6>
          <v-text-field
            v-model="rut"
            :error-messages="rutErrors"
            maxlength="15"
            label="Rut"
            :box="isDisabled || disableonmodifica"
            :readonly="isDisabled || disableonmodifica"
            @focusout="loadProveedor"
            @input="$v.rut.$touch()"
            @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
          ></v-text-field>
          <v-select
            v-model="regionValue"
            item-text="nombre"
            item-value="code"
            :items="regionesSelect"
            :error-messages="regionErrors"
            label="Región"
            :box="isDisabled || habilita"
            :readonly="isDisabled || habilita"
            @change="comunaFiltro()"
            @input="$v.regionValue.$touch()"
            @blur="tipeView == 'crear' ? $v.regionValue.$touch() : null"
          ></v-select>
          <v-text-field
            v-model="direccion"
            label="Direccion"
            :box="isDisabled"
            :readonly="isDisabled"
            @input="$v.direccion.$touch()"
            @blur="tipeView == 'crear' ? $v.direccion.$touch() : null"
          ></v-text-field>
          <v-text-field
            v-model="periodo"
            label="periodo"
            :error-messages="periodoErrors"
            :box="isDisabled || habilita"
            :readonly="isDisabled || habilita"
            @input="$v.periodo.$touch()"
            @blur="tipeView == 'crear' ? $v.periodo.$touch() : null"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md1></v-flex>
        <v-flex xs12 md6>
          <v-text-field
            v-model="razonSocial"
            :error-messages="razonSocialErrors"
            label="Razon Social"
            :box="isDisabled || habilita"
            :readonly="isDisabled || habilita"
            @input="$v.razonSocial.$touch()"
            @blur="tipeView == 'crear' ? $v.razonSocial.$touch() : null"
          ></v-text-field>
          <v-select
            v-model="comunaValue"
            :items="comunasSelect"
            item-text="nombre"
            item-value="code"
            :error-messages="comunaErrors"
            label="Comuna"
            :box="isDisabled || habilita"
            :readonly="isDisabled || habilita"
            @input="$v.comunaValue.$touch()"
            @blur="tipeView == 'crear' ? $v.comunaValue.$touch() : null"
          ></v-select>
          <v-textarea
            name="input-7-1"
            v-model="descripcion"
            label="Descripción"
            value
            counter
            maxlength="250"
            :disabled="tipeView == 'consulta'"
          ></v-textarea>
          <v-flex xs12 sm6></v-flex>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- CONTRATOS -->
    <template v-if="tipeView == 'crear'">
      <div>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">
            Contratos
            <v-btn
              v-if="tipeView != 'consulta'"
              class="btnValidarCargaMasiva"
              title="Nuevo contrato"
              @click="agregarFila()"
              >Agregar contrato</v-btn
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <p
          v-if="this.mostrarErrorSinContratos"
          class="v-messages theme--light error--text"
        >
          Debe agregar al menos un Contrato.
        </p>
        <p
          v-if="this.mostrarProcesoRepetido"
          class="v-messages theme--light error--text"
        >
          No puede haber procesos repetidos.
        </p>
        <p
          v-if="this.mostrarCamposObligatorios"
          class="v-messages theme--light error--text"
        >
          Todos los datos de los contratos son obligatorios.
        </p>
      </div>
      <template>
        <div>
          <fila-contrato
            v-for="(fila, index) in filas"
            :key="index"
            :fila="fila"
            :posicion="index"
            :procesoSelect="procesoSelect"
            @eliminar-fila="eliminarFila(index)"
          />
        </div>
      </template>
    </template>
    <template>
      <v-card-actions class="pb-3">
        <v-btn
          :loading="loading"
          v-if="tipeView == 'crear' || tipeView == 'modifica'"
          :disabled="false"
          color="primary"
          class="mb-2"
          @click="save(tipeView)"
        >
          Guardar
          <v-icon right dark>save</v-icon>
        </v-btn>
      </v-card-actions>
    </template>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import FilaContrato from "@/modules/configuration/contrato/FilaContrato.vue";

export default {
  name: "proveedor-data",
  components: {
    FilaContrato,
  },
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
  },
  data: (vm) => {
    return {
      razonSocial: "",
      rut: "",
      direccion: "",
      periodo: 0,
      regionValue: "",
      comunaValue: "",
      regionesSelect: [],
      comunasSelect: [],
      proceso: "",
      procesoSelect: [
        "IMPRESIÓN",
        "APLICACION",
        "CAPACITACION",
        "CAPTURA",
        "PREGUNTAS",
        "VALIDACIÓN",
      ],
      descripcion: "",
      itemContratoSelect: [],
      contrato: "",
      contratoId: "",
      id: "",
      loading: false,

      // CONTRATOS
      filas: [
        {
          codigo: "",
          itemContrato: "",
          proceso: "",
          fechaInicio: new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substring(0, 10),
          fechaInicioFormatted: vm.formatDate(
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substring(0, 10)
          ),
          fechaFin: new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substring(0, 10),
          fechaFinFormatted: vm.formatDate(
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substring(0, 10)
          ),
          menu1: false,
          menu2: false,
        },
      ],
      mostrarErrorSinContratos: false,
      mostrarCamposObligatorios: false,
      mostrarProcesoRepetido: false,
      fecha: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10),
      fechaFormat: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10)
      ),

      menu1: false,
      menu2: false,
      fechaInicio: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10),
      fechaInicioFormatted: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10)
      ),
      fechaFin: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      fechaFinFormatted: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10)
      ),
    };
  },

  validations: {
    rut: { required, maxLength: maxLength(15) },
    regionValue: { required },
    razonSocial: { required },
    direccion: { required },
    periodo: { required, maxLength: maxLength(4) },
    comunaValue: { required },
  },
  computed: {
    regionErrors() {
      const errors = [];
      if (!this.$v.regionValue.$dirty) return errors;
      !this.$v.regionValue.required && errors.push("La región es obligatoria.");
      return errors;
    },
    comunaErrors() {
      const errors = [];
      if (!this.$v.comunaValue.$dirty) return errors;
      !this.$v.comunaValue.required && errors.push("La comuna es obligatoria.");
      return errors;
    },
    razonSocialErrors() {
      const errors = [];
      if (!this.$v.razonSocial.$dirty) return errors;
      !this.$v.razonSocial.required &&
        errors.push("La razón social es obligatoria.");
      return errors;
    },
    periodoErrors() {
      const errors = [];

      if (!this.$v.periodo.$dirty) return errors;
      !this.$v.periodo.required && errors.push("El período es obligatorio.");
      //console.log("periodo::" + this.$v.periodo.$model);
      if (
        isNaN(this.$v.periodo.$model) ||
        Number(this.$v.periodo.$model) <= 0
      ) {
        errors.push("El período debe ser un valor numérico.");
        //console.log("ERROR!!!");
      }
      this.$v.periodo.$model.length > 4 &&
        errors.push("El período debe tener como máximo 4 caracteres.");
      return errors;
    },
    // procesoErrors() {
    //   const errors = [];
    //   if (!this.$v.proceso.$dirty) return errors;
    //   !this.$v.proceso.required && errors.push("El proceso es obligatorio.");
    //   return errors;
    // },
    rutErrors() {
      const errors = [];
      if (!this.$v.rut.$dirty) return errors;
      !this.$v.rut.required && errors.push("Rut es obligatorio.");
      this.$v.rut.$model.length > 15 &&
        errors.push("El RUT debe tener como máximo 15 caracteres.");
      return errors;
    },
    isDisabled() {
      if (this.tipeView && this.tipeView == "consulta") {
        return true;
      }
    },
    disableonmodifica() {
      if (this.tipeView && this.tipeView == "modifica") {
        return true;
      }
    },
    habilita() {
      if (this.tipeView && this.tipeView == "modifica") {
        return false;
      }
    },
  },
  watch: {
    fechaFin(val) {
      this.fechaFinFormatted = this.formatDate(this.fechaFin);
    },
    fechaInicio(val) {
      this.fechaInicioFormatted = this.formatDate(this.fechaInicio);
    },
  },
  mounted() {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    if (this.tipeView == "consulta") {
      this.loadData();
    }
    if (this.tipeView == "crear") {
      this.loadDataComuna();
    }
    if (this.tipeView == "modifica") {
      this.loadDataComuna();
      this.loadData();
    }
  },
  methods: {
    agregarFila() {
      this.mostrarCamposObligatorios = false;
      if (!this.filas) {
        console.log("no init");
        this.filas = [];
      }
      //console.log("st::add1:" + JSON.stringify(this.filas, null, 2));
      // console.log("fecha::" + this.fechaFormat + "::" + this.fecha + "::");
      this.filas.unshift({
        codigo: "",
        itemContrato: "",
        proceso: "",
        fechaInicio: this.fecha,
        fechaInicioFormatted: this.fechaFormat,
        fechaFin: this.fecha,
        fechaFinFormatted: this.fechaFormat,
        menu1: false,
        menu2: false,
      });
      this.mostrarErrorSinContratos = false;
      //console.log("st::add2:" + JSON.stringify(this.filas, null, 2));
    },
    eliminarFila(index) {
      this.mostrarCamposObligatorios = false;
      //console.log("st::delete1:" + JSON.stringify(this.filas, null, 2));
      this.filas.splice(index, 1);
      if (this.filas.length == 0) {
        this.mostrarErrorSinContratos = true;
      }

      //console.log("st::delete3:" + JSON.stringify(this.filas, null, 2));
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateToISO(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    save() {
      this.loading = true;
      if (this.tipeView == "crear") {
        this.saveContrato();
        this.loading = false;
      } else {
        this.editContrato();
        this.loading = false;
      }
    },
    validarFila(fila) {
      // console.log("st::fila:" + JSON.stringify(fila, null, 2));
      if (
        !fila.codigo ||
        fila.codigo.trim() == "" ||
        !fila.itemContrato ||
        fila.itemContrato.trim() == "" ||
        !fila.proceso ||
        fila.proceso.trim() == "" ||
        !fila.fechaInicio ||
        fila.fechaInicio.trim() == "" ||
        !fila.fechaFin ||
        fila.fechaFin.trim() == ""
      ) {
        this.mostrarCamposObligatorios = true;
        return "Todos los datos de los contratos son obligatorios";
      }
      //formateo fecha para envio
      fila.fechaInicio =
        fila.fechaInicio && fila.fechaInicio != null
          ? this.formatoFecha(fila.fechaInicio)
          : null;
      fila.fechaFin =
        fila.fechaFin && fila.fechaFin != null
          ? this.formatoFecha(fila.fechaFin)
          : null;

      // if (!/^\d+$/.test(fila.periodo)) {
      //   return "El período debe ser numérico1";
      // }
      return "";
    },
    saveContrato() {
      this.mostrarCamposObligatorios = false;
      this.mostrarProcesoRepetido = false;
      if (this.filas.length == 0) {
        this.mostrarErrorSinContratos = true;
        window.getApp.$emit(
          "ERROR_EXCEPTION",
          "Debe agregar al menos un Contrato"
        );
        return;
      }

      this.$v.$touch();
      // console.log("st::filas entra:" + JSON.stringify(this.filas, null, 2));
      var procesosUsados = [];
      //valida cada campo de cada fila con contratos
      for (let i = 0; i < this.filas.length; i++) {
        let result = this.validarFila(this.filas[i]);
        if (result == "") {
          if (procesosUsados.includes(this.filas[i].proceso)) {
            result = "No puede haber procesos repetidos.";
            this.mostrarProcesoRepetido = true;
          } else {
            procesosUsados.push(this.filas[i].proceso);
          }
        }
        if (result != "") {
          window.getApp.$emit("ERROR_EXCEPTION", result);
          return;
        }
      }
      if (!this.periodo || Number(this.periodo) <= 0) return;
      this.mostrarCamposObligatorios = false;
      // console.log("st::filas a enviar:" + JSON.stringify(this.filas, null, 2));
      this.$v.$touch();
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;

      this.body = {
        rut: this.rut,
        razonSocial: this.razonSocial,
        direccion: this.direccion,
        periodo: this.periodo,
        idComuna: this.comunaValue,
        idUserLogged: idUserLogged,
        subProceso: subProceso,
        descripcion: this.descripcion,
        listaContratos: this.filas,
      };

      axios
        .post("/proveedor/proveedorContrato", this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.$router.replace({ name: "ProveedorImpresion" }).catch(() => {
            //  console.log("catch saveContrato");
          });
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },
    editContrato() {
      this.loading = true;
      /// se debe validar el tipeo de los datos
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      let razonSoc = this.razonSocial;
      let dir = this.direccion;
      let idComuna = this.comunaValue.code;
      if (
        this.comunaValue.code == null ||
        this.comunaValue.code === "undefined"
      ) {
        idComuna = this.comunaValue;
      }
      this.body = {
        razonSocial: razonSoc,
        direccion: dir,
        periodo: this.periodo,
        idComuna: idComuna,
        idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        descripcion: this.descripcion,
        fechaInicio:
          this.fechaInicio && this.fechaInicio != null
            ? this.formatoFecha(this.fechaInicio)
            : null,
        fechaFin:
          this.fechaFin && this.fechaFin != null
            ? this.formatoFecha(this.fechaFin)
            : null,
      };

      axios
        .put("/proveedor/" + this.id, this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_UPDATE");
          this.$router.replace({ name: "ProveedorImpresion" }).catch(() => {
            //console.log("catch editrovider");
          });
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },
    async loadProveedorData() {
      return await axios
        .get("/contrato/" + this.contratoId)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadProveedor() {
      if (this.rut == "") return [];
      return await axios
        .get("/proveedor/rut/" + this.rut)
        .then((response) => {
          if (!response.data.code || response.data.code === "undefined") {
            this.prov = response.data;
            this.razonSocial = this.prov.razonSocial;
            this.direccion = this.prov.direccion;
            this.regionValue = this.prov.idComuna.idRegion.id;
            this.comunaValue = this.prov.idComuna.id;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadData() {
      this.contrato = await this.loadProveedorData();
      this.rut = this.contrato.proveedor.rut;
      this.id = this.contrato.proveedor.id;
      this.razonSocial = this.contrato.proveedor.razonSocial;
      this.direccion = this.contrato.proveedor.direccion;
      this.regionValue = {
        nombre: this.contrato.proveedor.idComuna.idRegion.nombre,
        code: this.contrato.proveedor.idComuna.idRegion.id,
      };
      this.regionesSelect = [
        {
          nombre: this.contrato.proveedor.idComuna.idRegion.nombre,
          code: this.contrato.proveedor.idComuna.idRegion.id,
        },
      ];
      this.comunaValue = {
        nombre: this.contrato.proveedor.idComuna.nombre,
        code: this.contrato.proveedor.idComuna.id,
      };
      this.comunasSelect = [
        {
          nombre: this.contrato.proveedor.idComuna.nombre,
          code: this.contrato.proveedor.idComuna.id,
        },
      ];
      this.direccion = this.contrato.proveedor.direccion;
      this.periodo = this.contrato.periodo;
      // this.codigoValue = this.contrato.codigo;
      // this.itemContratoValue = this.contrato.itemContrato;
      // this.periodoValue = this.contrato.periodo;
      // this.periodoSelect = [this.contrato.periodo];
      this.descripcion = this.contrato.descripcion;
      this.proceso = this.contrato.proceso;
      this.fechaInicio = this.formatDateToISO(this.contrato.fechaInicio);
      this.fechaFin = this.formatDateToISO(this.contrato.fechaFin);
    },
  },
};
</script>
